import React from 'react';
import { X } from 'lucide-react';

const T = {
  bg: 'var(--lyra-color-surface)',
  border: 'var(--lyra-color-border)',
  ink: 'var(--lyra-color-text)',
  ink4: 'var(--lyra-color-text-muted)',
  green: 'var(--lyra-color-success)',
};

export interface ConfirmScheduledRunModalProps {
  isOpen: boolean;
  onClose: () => void;
  scheduledAt?: string | Date | null;
  existingRunId?: string | null;
  onReplace?: () => void; // user chooses to replace existing scheduled run
  onKeep?: () => void; // user chooses to keep existing
}

const Header = ({ title, onClose }: { title: string; onClose?: () => void }) => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '12px 16px', borderBottom: `0.5px solid ${T.border}`,
  }}>
    <div style={{ fontSize: 14, fontWeight: 600, color: T.ink }}>{title}</div>
    {onClose && (
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.ink4 }}>
        <X size={16} />
      </button>
    )}
  </div>
);

const ModalWrapper: React.FC<{ children: React.ReactNode; wide?: boolean }> = ({ children, wide }) => (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 60 }}>
    <div style={{ background: T.bg, borderRadius: 12, width: '100%', maxWidth: wide ? 560 : 420, boxShadow: '0 8px 30px rgba(0,0,0,0.18)', margin: '0 16px', overflow: 'hidden' }}>
      {children}
    </div>
  </div>
);

export default function ConfirmScheduledRunModal({ isOpen, onClose, scheduledAt, onReplace, onKeep }: ConfirmScheduledRunModalProps) {
  if (!isOpen) return null;

  const fmt = (s?: string | Date | null) => {
    if (!s) return 'an unknown time';
    const d = (s instanceof Date) ? s : new Date(s);
    if (isNaN(d.getTime())) return String(s);
    return d.toLocaleString();
  };

  return (
    <ModalWrapper>
      <Header title="Scheduled run exists" onClose={onClose} />
      <div style={{ padding: 16 }}>
        <div style={{ color: T.ink, fontSize: 14, marginBottom: 12 }}>
          This agent run is already scheduled at: <strong>{fmt(scheduledAt)}</strong>
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={() => { onKeep && onKeep(); onClose(); }} style={{ background: 'none', border: '1px solid ' + T.border, padding: '8px 12px', borderRadius: 8, cursor: 'pointer' }}>
            Keep existing
          </button>
          <button onClick={() => { onReplace && onReplace(); onClose(); }} style={{ background: T.green, color: 'var(--app-on-accent)', border: 'none', padding: '8px 12px', borderRadius: 8, cursor: 'pointer' }}>
            Replace schedule
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
}
